import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import moment from "moment";
import "moment/locale/ar";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      backendOptions: [
        {
          loadPath: "/locales/{{lng}}/{{ns}}.json",
        },
      ],
    },
    debug: false,
    returnObjects: true,
    supportedLngs: ["en", "ar"],
    fallbackLng: "en",
    ns: [
      "common",
      "MainHomeDash",
      "placeholders",
      "alerts",
      "buttons",
      "tooltips",
      "sideBar",
      "skills",
      "devEnLangSkills",
      "placementTest",
      "interactiveSteps",
      "table",
      "queTypTraFSec",
      "writeSpeakCorrect",
      "practiceLesson",
      "wriSpeRevision",
      "validation",
      "messages",
      "subbox",
      "teacWriCorr",
      "balance",
      "teacherSettings",
      "calendar",
    ],
    defaultNS: "common",
    interpolation: {
      escapeValue: false,
    },
    react: {
      wait: true,
    },
  });

i18n.on("languageChanged", (lng) => {
  moment.locale(lng);
});

export default i18n;
